import React from 'react';
import { connect } from 'react-redux';
import { BREAKPOINT_SIZES } from 'tradera-constants/breakpoints';
import {
    selectMyTraderaState,
    setBreakPoint
} from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';

const MakeResponsive = ComposedComponent => {
    class Responsive extends React.Component {
        constructor(props) {
            super(props);
            this.removeMediaQueries = [];
        }

        componentDidMount() {
            if (window.matchMedia) {
                this.addMediaQueries();
            }
        }

        componentWillUnmount() {
            if (window.matchMedia && this.removeMediaQueries) {
                this.removeMediaQueries.forEach(removeMediaQuery =>
                    removeMediaQuery()
                );
            }
        }

        setBreakPoint = breakpoint => {
            this.props.dispatch(setBreakPoint(breakpoint));
        };

        addMediaQueries = () => {
            for (let breakpoint of Object.values(BREAKPOINT_SIZES)) {
                const matchMedia = window.matchMedia(
                    `screen and (min-width: ${breakpoint.min}px) and (max-width: ${breakpoint.max}px)`
                );
                if (matchMedia.matches) {
                    this.setBreakPoint(breakpoint);
                }
                const handleMediaChange = val => {
                    if (val.matches) {
                        this.setBreakPoint(breakpoint);
                    }
                };
                // addListener is an alias for addEventListener https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/addListener
                matchMedia.addListener(handleMediaChange);
                this.removeMediaQueries.push(() => {
                    matchMedia.removeListener(handleMediaChange);
                });
            }
        };

        render() {
            return <ComposedComponent {...this.props} />;
        }
    }

    const mapStateToProps = state => ({
        breakpoint: selectMyTraderaState(state).breakpoint
    });

    return connect(mapStateToProps)(Responsive);
};

export default MakeResponsive;
